(() => {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  const liveRegion = document.getElementById('SaLiveRegion');
  const announce = (message) => {
    if (!liveRegion || !message) return;
    liveRegion.textContent = '';
    window.setTimeout(() => {
      liveRegion.textContent = message;
    }, 50);
  };

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    if (!input) return;

    wrapper.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.quantityChange || 0);
        const current = Number(input.value || 1);
        const min = input.min !== '' ? Number(input.min) : 1;
        const max = input.max !== '' ? Number(input.max) : Infinity;
        const next = Math.min(max, Math.max(min, current + direction));
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantInput = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const addButton = root.querySelector('[data-add-to-cart]');
    if (!variantInput) return;

    const updateFromData = (source) => {
      if (!source) return;
      const available = String(source.dataset.available) === 'true';

      if (price && source.dataset.price) {
        price.textContent = source.dataset.price;
      }

      if (compare) {
        const compareValue = source.dataset.compare || '';
        compare.textContent = compareValue;
        compare.hidden = compareValue === '';
      }

      const stockNote = root.querySelector('[data-stock-note]');
      if (stockNote) {
        const raw = source.dataset.inventory;
        const inv = raw === undefined || raw === '' ? NaN : Number(raw);
        const threshold = Number(stockNote.dataset.threshold || 0);
        const isMto = stockNote.dataset.mto === 'true';
        if (available && Number.isFinite(inv) && inv > 0 && inv <= threshold) {
          if (isMto) {
            stockNote.textContent = inv === 1 ? 'Last spot open this round' : 'Only ' + inv + ' spots left this round';
          } else {
            stockNote.textContent = inv === 1 ? 'Only 1 left' : 'Only ' + inv + ' left';
          }
          stockNote.hidden = false;
        } else {
          stockNote.hidden = true;
        }
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.dataset.availableLabel || 'Add to bag'
          : addButton.dataset.soldOutLabel || 'Sold out';
      }
    };

    const mediaWrap = root.querySelector('[data-product-media]');

    // Show the photo that belongs to the chosen option (e.g. the Rose charm)
    const showVariantMedia = (option) => {
      if (!mediaWrap || !option || !option.dataset.mediaId) return;
      const item = document.getElementById('Media-' + option.dataset.mediaId);
      if (!item || item === mediaWrap.firstElementChild) return;
      mediaWrap.insertBefore(item, mediaWrap.firstElementChild);
      mediaWrap.scrollLeft = 0;
      if (window.innerWidth > 650) {
        const top = mediaWrap.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    const updateVariantUi = (fromUser) => {
      if (variantInput.tagName === 'SELECT') {
        const option = variantInput.options[variantInput.selectedIndex];
        updateFromData(option);
        if (fromUser) {
          showVariantMedia(option);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        updateFromData(variantInput);
      }
    };

    if (variantInput.tagName === 'SELECT') {
      variantInput.addEventListener('change', () => updateVariantUi(true));
    }
    updateVariantUi(false);
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-filter-form]').forEach((form) => {
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
  });

  document.querySelectorAll('[data-search-clear]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = button.closest('form');
      const input = form ? form.querySelector('input[type="search"]') : null;
      if (!input) return;
      input.value = '';
      input.focus();
    });
  });

  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-quantity]')) {
        announce('Cart quantity changed. Select Update bag to refresh your total.');
      }
    });
  });
})();
